export default {
    title: "Nástenka",
    text_0: "Môj dashboard",
    text_1: "Hodnota ponúk tento mesiac",
    text_2: "Celková hodnota ponúk",
    text_3: "Počet klientov",
    text_4: "Počet Moje firmy",
    text_5: "Počet Položky a ceny",
    text_6: "Počet integrácií SuperFaktura",
    text_7: "Počet užívateľov bez ponuky",
    text_8: "Počet užívateľov s 1 ponukou",
    text_9: "Počet užívateľov s 2-5 ponukami",
    text_10: "Počet užívateľov s viac ako 5 ponukami",
    text_11: "Počet všetkých užívateľov",
    text_12: "Počet všetkých ponuk",
    text_13: "Počet všetkých klientov",
    text_14: "Počet tmavých ponúk",
    text_15: "Počet svetlých ponúk",
    text_16: "Hodnota tvojich ponúk",
    text_17: "Počet tvojich ponúk",
    text_18: "Zaregistrovaní užívatelia",
    text_19: "Počet všetkých ponúk",
    text_20: "TOP 10 používateľov podľa počtu ponúk",
    text_21: "Tvoje posledné ponuky",
    text_22: "Prejsť na všetky ponuky",
    text_23:
        "Aktuálne nemáš vytvorené žiadne cenové ponuky. Nechceš nejakú vytvoriť?",
    text_24: "Vytvoriť ponuku",
    text_25: "Odoslané emaily",
    text_26: "Oblasť podnikania",
    text_27: "Zdroj kontaktov",
    text_28: "Priemerná hodnota všetkých ponúk",
    text_29: "TOP 10 používateľov podľa celkovej ceny ponúk",
    text_30: "TOP 10 používateľov podľa priemernej ceny ponúk",
    text_31: "Stavy cenových ponúk",
};
